/**
 * Zentrale Debug-Helfer. Alle Aufrufe werden im Production-Build
 * vom Terser-Minifier komplett entfernt, weil das `if`-Konstrukt
 * per `process.env.NODE_ENV` (via Webpack DefinePlugin) zu einem
 * konstanten `false` aufgelöst wird.
 *
 * Warum das wichtig ist:
 *  - Alle `console.log('🔧 …')`-Statements landen sonst im Browser
 *    der Kunden – DevTools sehen aus wie ein Bastelplatz.
 *  - Fehler und echte Warnungen sollen weiterhin sichtbar sein,
 *    darum bleiben `debugError` und `debugWarn` auch in Produktion
 *    aktiv.
 *
 * Benutzung:
 *   import { debug, debugWarn, debugError } from '../utils/debug';
 *   debug('State updated', newState);
 *   debugWarn('API antwortet langsam', ms);
 *   debugError('Preis-API failed', err);
 */

const isDev = process.env.NODE_ENV !== 'production';

/**
 * Nur im Development-Build sichtbar. Nutze das für alle Emoji-Logs
 * (🔧, 📏, ✓ etc.), die dir beim Debuggen helfen, aber nichts im
 * Kunden-Browser zu suchen haben.
 */
export function debug(...args: unknown[]): void {
  if (isDev) {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
}

/**
 * Auch in Produktion sichtbar. Nutze das für echte, aber nicht
 * kritische Warnungen (z.B. Fallback-Nutzung, langsame Netzwerk-
 * Antworten).
 */
export function debugWarn(...args: unknown[]): void {
  // eslint-disable-next-line no-console
  console.warn(...args);
}

/**
 * Auch in Produktion sichtbar. Für Fehler, die für Support wichtig
 * sein könnten (API-Failures, unerwartete State-Situationen).
 */
export function debugError(...args: unknown[]): void {
  // eslint-disable-next-line no-console
  console.error(...args);
}
